export const HEADING_SIZE = [1, 2, 3, 4, 5, 6] as const
